"use client";

import type { VariantProps } from "class-variance-authority";
import { createContext, use } from "react";

import type { rootStyles } from "./styles";

export const CardContext = createContext<Partial<VariantProps<typeof rootStyles>>>({});

export const useCardContext = () => use(CardContext);
